<template>
  <div class="dont-print">
    <date-picker v-model="days" valueType="format" :clearable="false" range />
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'GenericDaysSelector',
  inject: ['page'],
  props:[
    'storeName',
    'format',
    'willLoadData'
  ],
  mixins : [formatDataMixin],
  data(){
    return {
      loadData: false,
      days: [],
    }
  },
  mounted(){
    this.days = [this.timestamps.from, this.timestamps.to]
    if(this.willLoadData === true){
      this.$set(this.timestamps, 'from', moment(this.timestamps.from).startOf(this.timestamps.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.$set(this.timestamps, 'to', moment(this.timestamps.from).endOf(this.timestamps.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.store.loadData();
    } 
  },
  watch:{
    timestamps: {
      deep: true,
      handler(){
        this.loadData = false
        this.days = [this.timestamps.from, this.timestamps.to]
      }
    },
    days: {
      // immediate: true,
      handler(newVal, oldVal) {
        // console.log('GDS', newVal, oldVal, oldVal.length)
        this.$set(this.timestamps, 'from', moment(newVal[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
        this.$set(this.timestamps, 'to', moment(newVal[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
        console.log('Debug', oldVal.length > 0 , this.loadData, oldVal.length > 0 && this.loadData)
        if(oldVal.length > 0 && this.loadData){
          this.store.loadData();
        }
        this.loadData = true;
        console.log('Generic Days Selector', newVal, JSON.stringify(this.timestamps))
      },
    },
  },
  components : {DatePicker},
  inject: ['page'],
  computed:{
    store(){return this.page.$refs[this.storeName]},
    timestamps(){ return this.store.timestamps},
    dateKey(){ return this.timestamps.dateKey},
  },
  methods:{
    
  }
}
</script>